import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgBlockedUserPlaceholderM = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 18,
        cy: 18,
        r: 18,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 18,
        cy: 18,
        r: 18,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 18,
        cy: 18,
        r: 18,
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38
      }), /*#__PURE__*/jsx("circle", {
        cx: 18,
        cy: 18,
        r: 16.2,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M22.534 20.707a5.72 5.72 0 0 0 1.844-4.211v-3.214a5.743 5.743 0 0 0-5.743-5.743h-1.27a5.743 5.743 0 0 0-5.743 5.743v3.214c0 1.666.71 3.163 1.844 4.211 1.108 1.025 1.064 2.79-.108 3.739a4.7 4.7 0 0 1-1.354.764c-1.898.689-4.293 1.703-6.06 2.949a.4.4 0 0 0-.065.585A16.16 16.16 0 0 0 18 34.2c4.824 0 9.153-2.11 12.12-5.456a.4.4 0 0 0-.065-.585c-1.766-1.246-4.16-2.26-6.059-2.949a4.7 4.7 0 0 1-1.353-.764c-1.174-.95-1.217-2.714-.109-3.74z"
      }), /*#__PURE__*/jsx("circle", {
        cx: 25.335,
        cy: 24.3,
        r: 6,
        fill: "#9EA0A0"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        fillRule: "nonzero",
        d: "M25.335 17.775a6.525 6.525 0 1 1 0 13.05 6.525 6.525 0 0 1 0-13.05m0 1.8a4.725 4.725 0 1 0 0 9.45 4.725 4.725 0 0 0 0-9.45"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        fillRule: "nonzero",
        d: "m28.87 20.102 1.272 1.273-8.072 8.072-1.273-1.272z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgBlockedUserPlaceholderM$1 = SvgBlockedUserPlaceholderM;

export { SvgBlockedUserPlaceholderM$1 as default };
